/* eslint-disable */
import React, { PropTypes } from 'react';
import { FormattedMessage } from  'react-intl';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import cn from 'classnames';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { siteShape, accountShape } from '@bibliocommons/bc-prop-types';
import { locationShape } from 'react-router/lib/PropTypes';
import * as Drawer from '@bibliocommons/base-drawer';
import { TextButton } from '@bibliocommons/base-buttons';
import { Card as CardIcon } from '@bibliocommons/base-icons';

import CheckedOutStatus from '../../checkouts/CheckedOutStatus';
import HoldsStatus from '../../holds/HoldsStatus';
import FinesStatus from '../../fines/FinesStatus';
import RecentlyReturnedStatus from '../../recentlyreturned/RecentlyReturnedStatus';
import AccountMessagesStatus from '../../accountmessages/AccountMessagesStatus';
import SingleClickHoldsPanelContainer from '../../../../containers/SingleClickHoldsPanelContainer';
import AccountExpiryWarning from '../AccountExpiryWarning';
import LinkableLibrariesPanel from '../LinkableLibrariesPanel';
import InterlibaryLoansStatus from '../../interlibraryLoans/InterlibraryLoansStatus';

import './MyBorrowingSidebar.scss';
class MyBorrowingSidebar extends BcReactComponent {
  isActive(section) {
    return this.props.activeSection === section;
  }

  showLinkableLibraries() {
    const unlinkedLibraries = this.props.linkableLibraries
      .filter(library => !this.props.accountsByLibraryId.has(library.get('libraryId')));

    return unlinkedLibraries.size > 0;
  }

  renderSingleClickHoldsWidget() {
    if (this.props.activeSection === 'holds') {
      return (
        <SingleClickHoldsPanelContainer />
      );
    }
  }

  renderTitle() {
    const { libraryName } = this.props;
    return (
      <h3>
        <div className="my-borrowing-at">
          <CardIcon />
          <FormattedMessage id="section_title_my_borrowing" />
        </div>
        <div className="lib-at">
          <FormattedMessage
            id="at_library"
            values={{ library: <strong>{libraryName}</strong> }} />
        </div>
      </h3>
    );
  }

  pathnameHasChanged(prevProps) {
    return this.props.location.pathname !== prevProps.location.pathname;
  }

  componentDidUpdate(prevProps) {
    const { drawer, drawerActions } = this.props;

    if (drawer.get('open') && this.pathnameHasChanged(prevProps)) {
      drawerActions.toggle();
    }
  }

  render() {
    const { 
      account, 
      isRecentlyReturnedEnabled, 
      isAccountMessagesEnabled, 
      isRemainingHoldsEnabled,
      isIllRequestsEnabled,
      showCardExpiryDate } = this.props;
    const expiryDate = account.get('expiryDate');

    return (
      <div className="cp-my-borrowing-sidebar">
        <div className="panel panel-default">
          <div className="close-drawer">
            <Drawer.Toggle drawerActions={this.props.drawerActions}>
              <TextButton handleClick={this.props.drawerActions.toggle}>
                <span className="icon icon-left-open" />
                Close
              </TextButton>
            </Drawer.Toggle>
          </div>

          <div className="panel-heading">
            {this.renderTitle()}
          </div>
          <div className="panel-body">
            <div className="list-group">
              {showCardExpiryDate && <AccountExpiryWarning expiryDate={expiryDate} />}
              <HoldsStatus
                summary={this.props.holdsSummary}
                currentSection={this.isActive('holds')}
                ILSQuotas={this.props.ILSQuotas}
                isRemainingHoldsEnabled={isRemainingHoldsEnabled}/>
              <CheckedOutStatus
                summary={this.props.checkoutSummary}
                currentSection={this.isActive('checkedout')} />
              {isRecentlyReturnedEnabled && <RecentlyReturnedStatus
                totalBorrowingHistory={this.props.totalBorrowingHistory}
                currentSection={this.props.activeSection === 'recentlyreturned'} />}
              <FinesStatus
                totalFines={this.props.totalFines}
                currentSection={this.props.activeSection === 'fines'} />
              {isAccountMessagesEnabled && <AccountMessagesStatus
                messages={this.props.messages}
                currentSection={this.props.activeSection === 'accountmessages'} />}
              {isIllRequestsEnabled && <InterlibaryLoansStatus
                summary={this.props.illSummary}
                currentSection={this.props.activeSection === 'interlibraryloans'} />}
            </div>
          </div>
          {this.renderSingleClickHoldsWidget()}
          {this.showLinkableLibraries() && <LinkableLibrariesPanel
            accountsByLibraryId={this.props.accountsByLibraryId}
            linkableLibraries={this.props.linkableLibraries} />}
        </div>
      </div>
    );
  }
}

MyBorrowingSidebar.propTypes = {
  account: accountShape,
  activeSection: PropTypes.string.isRequired,
  libraryName: PropTypes.string,
  linkableLibraries: ImmutablePropTypes.listOf(siteShape),
  checkoutSummary: ImmutablePropTypes.mapContains({
    nextDue: ImmutablePropTypes.mapContains({
      date: PropTypes.string,
      status: PropTypes.string
    })
  }),
  totalFines: PropTypes.number.isRequired,
  totalBorrowingHistory: PropTypes.number.isRequired,
  ILSQuotas: ImmutablePropTypes.map,
  messages: ImmutablePropTypes.map.isRequired,
  status: ImmutablePropTypes.mapOf(PropTypes.number, PropTypes.string),
  accountsByLibraryId: ImmutablePropTypes.mapOf(accountShape),
  drawerActions: PropTypes.objectOf(PropTypes.func),
  isRecentlyReturnedEnabled: PropTypes.bool,
  isAccountMessagesEnabled: PropTypes.bool,
  isRemainingHoldsEnabled: PropTypes.bool,
  isIllRequestsEnabled: PropTypes.bool,
  illSummary: PropTypes.map,
  showCardExpiryDate: PropTypes.bool,
  location: locationShape,
  drawer: ImmutablePropTypes.mapContains({
    open: PropTypes.bool
  })
};

export default MyBorrowingSidebar;



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/MyBorrowingSidebar/MyBorrowingSidebar.jsx